const KEY = "crm_theme";

export function getStoredTheme() {
  const saved = localStorage.getItem(KEY);
  if (saved === "light" || saved === "dark") return saved;
  // First-time users always land on dark mode — the app's primary, most-polished identity
  // — regardless of their OS preference. They can switch to light anytime via the toggle;
  // that choice is what gets remembered from then on.
  return "dark";
}

export function applyTheme(theme) {
  const root = document.documentElement;
  if (theme === "light") root.classList.add("light");
  else root.classList.remove("light");
}

export function initTheme() {
  applyTheme(getStoredTheme());
}

export function setTheme(theme) {
  localStorage.setItem(KEY, theme);
  applyTheme(theme);
}
